import { render, staticRenderFns } from "./DepartmentTypeSelect.vue?vue&type=template&id=1c49f5de&"
import script from "./DepartmentTypeSelect.vue?vue&type=script&lang=ts&"
export * from "./DepartmentTypeSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
